import { Link } from "react-router-dom";
import {
  Mail,
  Phone,
  MapPin,
  Linkedin,
  Twitter,
  Youtube,
  ArrowUpRight,
} from "lucide-react";

import { FOOTER } from "../constants/testIds/site";

const linkCls =
  "text-sm text-primary hover:text-white transition-colors duration-200";

export default function Footer() {
  return (
    <footer
      data-testid={FOOTER.root}
      className="relative bg-slate-300 text-white"
    >
      <div className="section-x mx-auto max-w-[1440px] pt-20 pb-10">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          {/* Company */}
          <div className="md:col-span-4">
            <div className="flex items-center gap-3">
              <img
                src="/Logonew.png"
                alt="Buildwit Technology"
                className="h-20 w-auto object-contain"
              />
            </div>

            <div className="mt-4 space-y-1 text-sm text-primary">
              <p>GSTIN: 06AA0CB3710D1Z2</p>
              <p>CIN: U28120HR2026PTC141071</p>
            </div>

            <p className="mt-6 max-w-sm text-sm leading-relaxed text-primary">
              Engineered industrial automation for the government and enterprise
              sectors — designed, manufactured and commissioned in India since
              2026.
            </p>

            <div className="mt-8 flex gap-3">
              {[Linkedin, Twitter, Youtube].map((Icon, index) => (
                <a
                  key={index}
                  href="#"
                  className="inline-flex h-9 w-9 items-center justify-center rounded-md border border-white/10 text-primary transition-colors duration-200 hover:border-white/30 hover:text-white"
                >
                  <Icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>

          {/* Company Links */}
          <div className="md:col-span-2">
            <h4 className="mb-4 text-xs font-semibold uppercase tracking-[0.22em] text-accent">
              Company
            </h4>

            <ul className="space-y-3">
              <li>
                <Link to="/about" className={linkCls}>
                  About Us
                </Link>
              </li>

              <li>
                <Link to="/industries" className={linkCls}>
                  Industries
                </Link>
              </li>

              <li>
                <Link to="/products" className={linkCls}>
                  Products
                </Link>
              </li>

              <li>
                <Link to="/contact" className={linkCls}>
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-3">
            <h4 className="mb-4 text-xs font-semibold uppercase tracking-[0.22em] text-accent">
              Reach Us
            </h4>

            <ul className="space-y-4 text-sm text-primary">
              <li className="flex items-start gap-3">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-accent" />
                <span>
                  Shop no. 19, H.B colony, Sector 22
                  <br />
                  Faridabad 121005, India
                </span>
              </li>

              <li className="flex items-center gap-3">
                <Phone className="h-4 w-4 shrink-0 text-accent" />
                <span>+91 8178799057</span>
              </li>

              <li className="flex items-center gap-3">
                <Mail className="h-4 w-4 shrink-0 text-accent" />
                <span>sales@buildwit.in</span>
              </li>
            </ul>
          </div>

          {/* CTA */}
          <div className="md:col-span-3">
            <h4 className="mb-4 text-xs font-semibold uppercase tracking-[0.22em] text-accent">
              Ready to build?
            </h4>

            <p className="text-sm leading-relaxed text-primary">
              Get an engineering-led proposal within one business day.
            </p>

            <Link
              to="/contact"
              data-testid={FOOTER.ctaBtn}
              className="mt-5 inline-flex h-11 items-center gap-2 rounded-md bg-accent px-5 text-sm font-semibold text-white transition-colors duration-200 hover:bg-accent-hover"
            >
              Start an enquiry
              <ArrowUpRight className="h-4 w-4" />
            </Link>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-16 flex flex-col items-start justify-between gap-3 border-t border-white/10 pt-6 text-xs text-accent md:flex-row md:items-center">
          <div>
            © {new Date().getFullYear()} Buildwit Technology Pvt. Ltd. All
            rights reserved.
          </div>

          <div className="flex items-center gap-6">
            <span>ISO 9001:2015</span>
            <span>CE Certified</span>
            <span>MSME Registered</span>
          </div>
        </div>
      </div>
    </footer>
  );
}